/* eslint-disable  */
import DataTable from "react-data-table-component";
// import data from './data.json';
import React, { useState,useEffect } from "react";
import {  Button } from "@mui/material";
// import Dashboard from "./Dashboard";
//  import Navbar from './Navbar';
//  import Sidebar from './Sidebar';
 import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
 import {  SvgIcon } from "@mui/material";
//  import { useLocation, useNavigate } from "react-router-dom";
 import Box from '@mui/material/Box';
 import {get} from '../library/Api';
 import EditIcon from '@mui/icons-material/Edit';
//  import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
 import DialogContent from '@mui/material/DialogContent';
 import DialogTitle from '@mui/material/DialogTitle';
 import Slide from '@mui/material/Slide';
 import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
 import { styled } from '@mui/material/styles';
 import Dialog from '@mui/material/Dialog';
import EditvehicleForm from "./vehicleEditForm";
// import { faRubleSign } from "@fortawesome/free-solid-svg-icons";


 const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  // '& .MuiDialog-paperWidthSm': {
  //   maxWidth: '800',
  // },
  '& .MuiTextField-root' : {
    width: '48%',
  },
  // '& .MuiBox-root' : {
  //   textAlign: 'center',
  // },
}));



function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}








export function VehicleForm({vehiclelist_data,updateVisibility}) {
  const [datas, setDatas] = useState([]);
  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState([]);
  // const location = useLocation();
  // const navigate = useNavigate();
  const [add_visible,setAddVisible] = useState(false)
  const [addoptionlabel,setAddOPtionLabel] = useState('ADD');
  const [cust_id, setCustomer_id] = useState(vehiclelist_data);
  console.log(cust_id,"--------c--custyy = ",vehiclelist_data)


  const myNewTheme= {
    rows: {
      fontSize: '50px'
    }
  }
  const handleClose = () => setShow(false);
  const handleEdit = (row) =>{  setRowData(row);setShow(true); console.log("++++",rowData) }

  const columns = [
    // {
    //   name: "Customer ID",
    //   selector: "customer_id",
    //   sortable: true,
    //   // cell: row => <div style={{fontSize: 20}}>{row.firstName}</div>
    // },
    
    {
      name: "Model",
      selector: "make_model",
      // sortable: true,
    },
    {
      name: "Colour",
      selector: "color",
      // sortable: true,
    },
    {
      name: "License Plate",
      selector: "license_plate",
    },
    
    {
      name: "State",
      selector: "state",
    },
    // {
    //   name: "Parking Spot",
    //   selector: "parking_spot",
    // },
    // {
    //   name: "Company",
    //   selector: "company",
    // },
    {
      name: "Edit",
      selector: (row) => (
        <div>
           <a href="#" onClick={(e) => { console.log("this row = ",row)
      handleEdit(row);}} >
              <EditIcon />
            </a>
         
        </div>
      ),
    },  
    // {
    //   name: "Delete",
    //   cell: (row) => (
    //     <div>
         
    //      <a href="#" 
    //           className="text-danger"  data-toggle="modal" >
    //           <DeleteOutlineIcon />
    //         </a>
    //     </div>
    //   ),
    // },
     
  ];



  const HandleClicks = (e) => {
  
    // if (location.pathname === "/vehicle") {
    //   navigate("/vehicle");
    // } else {
    //   navigate("/vehicle");
    // }
    console.log("add visibilitytyyyy ----",add_visible)
    const newdata = !add_visible
    setAddVisible(newdata)
    updateVisibility(newdata)

    // if(addoptionlabel=='ADD'){
    //   setAddOPtionLabel("Close")
    // }
    // else{
    //   setAddOPtionLabel('ADD')
    // }
   

  };

  // {
    //     params: { company: company }
    //   }
   
  useEffect(() => {
    if(cust_id){
    console.log("------>>---custid---------->>--",cust_id)
    get(`list_vehicledata`,{params :{id:cust_id}}).then((res) => {
      const data = res;
      console.log("kkkk",data.data);
      setTimeout(() => {
        setDatas(data.data);
      }, 1000);
     
    
    },[]);}
  }, [rowData],[show][datas]);

  useEffect(()=>{
    // console.log("---------------------------------------------------------------------->>")
    setCustomer_id(vehiclelist_data)
    updateVisibility(false)
    setAddVisible(false)
    setAddOPtionLabel("ADD")
    // console.log("------------->>-add_visible-------closed changes---->>",add_visible)
  },[vehiclelist_data])

 
  

  return (
    <>
    {/* <Navbar name="Dashboard" /> */}
    <Box sx={{ display: 'flex' }}>
    {/* <Sidebar /> */} 
    <Box component="main" sx={{ flexGrow: 1, p: 0, mt: 0  }}>
    <div className="App">
    <div className="d-flex align-items-center justify-content-between mb-3">
      <h3 className="heading-style">
        Vehicle Details
      
      </h3>

      <div>

        <Button
        className="btn-sty"
          onClick={HandleClicks}
          startIcon={
            <SvgIcon fontSize="small">
              <PlusIcon />
            </SvgIcon>
          }
          variant="contained"
        >
          {addoptionlabel}
        </Button>
      </div>
      </div>
      
      <DataTable
        title=""
        columns={columns}
        data={datas}
        highlightOnHover
        customTheme={myNewTheme}
        // pagination
        // paginationPerPage={5}
        // paginationRowsPerPageOptions={[5, 15, 25, 50]}
        // paginationComponentOptions={{
        //   rowsPerPageText: "Records per page:",
        //   rangeSeparatorText: "out of",
        // }}
        className="table-style"
      />
    </div>
    </Box>
    </Box>
        {/* ----------------in edit  */}

    <div>
      <BootstrapDialog
        open={show}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        className="m-0 w-100"
        fullScreen
      >
        <BootstrapDialogTitle id="customized-dialog-title" className="heading-style bg-gray" onClose={handleClose}>{"Edit Vehicle"}</BootstrapDialogTitle>
       <DialogContent >

       {/* <EditForm theEmployee = {rowData}/> */}
       <EditvehicleForm vehicle_form_data={rowData} onClosetab = {handleClose}/>
       </DialogContent>
       {/* <DialogActions>
          <Button autoFocus  className="btn-sty "onClick={handleClose}>Close</Button>
          </DialogActions> */}
      </BootstrapDialog>
    </div>
    </>
  );
}

export default VehicleForm;
